import { format } from "date-fns"
import { useState } from "react"
import { ArrowRight } from "react-feather"
import type { TicketGet200TicketTicketCommentsItem } from "@/api/client/ticket"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface TicketCommentCardProps {
  progressNumber: number
  comment: TicketGet200TicketTicketCommentsItem
  fromName: string
  toName: string
  title: string
}

export function TicketCommentCard({
  progressNumber,
  comment,
  fromName,
  toName,
  title,
}: TicketCommentCardProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const maxLength = 200
  const shouldShowMore = comment.content.length > maxLength

  const displayText =
    isExpanded || !shouldShowMore
      ? comment.content
      : `${comment.content.substring(0, maxLength)}...`

  return (
    <Card className="overflow-hidden">
      <div className="flex">
        <div className="flex w-8 shrink-0 items-center justify-center border-r">
          <span className="text-sm font-medium text-slate-700">{progressNumber}</span>
        </div>
        <div className="min-w-0 flex-1">
          <CardHeader className="bg-slate-100 py-3">
            <div className="space-y-2">
              <div className="flex justify-between items-center text-xs text-slate-500 font-semibold">
                <span>{title}</span>
                <span>{format(new Date(comment.contactAt), "yyyy-MM-dd HH:mm")}</span>
              </div>
              <div className="flex items-center gap-2 flex-wrap text-sm font-semibold text-slate-600">
                <span>{fromName}</span>
                <ArrowRight className="h-3.5 w-3.5" />
                <span>{toName}</span>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="relative">
              <p className="text-sm text-slate-600 whitespace-pre-wrap leading-6">{displayText}</p>
              {shouldShowMore && !isExpanded && (
                <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent pointer-events-none" />
              )}
            </div>
            {shouldShowMore && (
              <Button
                variant="link"
                size="sm"
                className="mt-2 p-0 h-auto text-slate-600"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? "閉じる" : "もっと見る"}
              </Button>
            )}
          </CardContent>
        </div>
      </div>
    </Card>
  )
}
